import { getBaseUrlFromEnv } from '../system/baseUrl';
const CookieValidity = {
    valid: 604800,
    invalid: 0
};
class CookiesServiceSingleton {
    constructor() {
        this.processValue = (value) => {
            /*if (value === 'true') return true;
            if (value === 'false') return false;
            if (value === 'undefined') return undefined;
            if (value === 'null') return null;*/
            return value;
        };
        this.decode = (str) => {
            if (!str)
                return str;
            return str.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
        };
        this.domain = getBaseUrlFromEnv() || 'localhost';
        this.path = '/';
        this.maxAge = CookieValidity.valid; // 7 days validity for cookies;
        this.maxAgeInvalid = CookieValidity.invalid; // 0 for cookie invalidation;
    }
    static getInstance() {
        if (!CookiesServiceSingleton.instance) {
            CookiesServiceSingleton.instance = new CookiesServiceSingleton();
        }
        return CookiesServiceSingleton.instance;
    }
    getCookies() {
        if (document.cookie === '') {
            return {};
        }
        const cookiesArray = document.cookie ? document.cookie.split(';') : [];
        return cookiesArray.reduce((obj, cookie) => {
            const [key, value] = cookie.split('=');
            //obj[key.trim()] = isJSON(value) ? JSON.parse(value) : value;
            obj[key.trim()] = value;
            return obj;
        }, {});
    }
    getCookie(key) {
        const cookies = this.getCookies();
        const value = cookies[key];
        return this.processValue(this.decode(value));
    }
    setCookie({ key, value }) {
        const preparedValue = typeof value !== 'string' ? JSON.stringify(value) : value;
        document.cookie = `${key}=${preparedValue};path=${this.path};domain=${this.domain};max-age=${this.maxAge};`;
    }
    removeCookie({ key }) {
        document.cookie = `${key}=null;path=${this.path};domain=${this.domain};max-age=${this.maxAgeInvalid};`;
    }
    clearAllCookies() {
        const cookies = this.getCookies();
        Object.keys(cookies).forEach((key) => {
            this.removeCookie({ key });
        });
    }
}
const CookiesService = CookiesServiceSingleton.getInstance();
export default CookiesService;
